@if (isLoading && !displayedItems.length) {
<app-loading-indicator [isLoading]="isLoading" class="load-indicator" id="networksPage"></app-loading-indicator>
}

<div class="ziti-page-container lt-skin-page">
    <lib-list-table-header
        title="Networks"
        subtitle="Manage the networks in your account"
        createLabel="Create Network"
        infoText="A network is a separate Ziti fabric with its own controller, routers, identities and services."
        [tabs]="tabs"
        [showAdd]="!hasSelection"
        [blockCreate]="createBlocked"
        [blockDelete]="deleteBlocked"
        (actionClicked)="onHeaderAction($event)"
    >
        <span header-icon class="icon-ManageNetworks" aria-hidden="true"></span>
    </lib-list-table-header>

    <lib-list-table
        class="lt-skin"
        [tableId]="tableId"
        [initialPageSize]="initialPageSize"
        [options]="tableOptions"
        [columns]="listColumns"
        [rowData]="rows"
        [isLoading]="isLoading"
        [hasNext]="hasNext"
        [hasPrev]="hasPrev"
        [startCount]="startCount"
        [endCount]="endCount"
        [totalCount]="totalElements"
        [filterApplied]="filterApplied"
        [filterColumn]="searchFilter"
        [menuItems]="menuItems"
        [headerActions]="headerActions"
        filterName="Network name"
        entityTypeName="networks"
        noItemsImage="nodata"
        [showNoItemsAdd]="!createBlocked"
        [noItemsReadonly]="createBlocked"
        (selectionChanged)="onSelection($event)"
        (actionRequested)="onAction($event)"
    ></lib-list-table>
</div>
